$('.stars__star').hover(function(){ 
	if(!$(this).parent().hasClass('set')){ 
		$(this).parent().find('.stars__star').removeClass('active'); 
		$(this).addClass('active'); 
		$(this).prevAll().addClass('active'); 
	} 
},function(){ 
	if(!$(this).parent().hasClass('set')){ 
		$(this).parent().find('.stars__star').removeClass('active'); 
	} 
}) 
$('.stars__star').on('click',function(){ 
	$(this).parent().addClass('set'); 
	$(this).parent().find('.stars__star').removeClass('active'); 
	$(this).addClass('active'); 
	$(this).prevAll().addClass('active'); 
})

function mobileStars(){
	var $parent = $('.reviews-block__footer').first(),
			$elemPrev = $parent.find('.reviews-block__rating'),
			$elem = $elemPrev.next('.stars');

	var replaceElem = function(){
		if ($(window).outerWidth() < 992 && $elem.length == 1) {
			$parent.after($elem);
		}else{
			$elemPrev.after($elem);
		}
	}
	replaceElem();

	$(window).resize(function(){
		replaceElem();
	})
}
mobileStars();